import { type ReportTemplate } from 'reportingSolution/constants'

const config: ReportTemplate = {
  id: 'creative_insights_report',
  active: true,
  label: 'Creative Insights Report',
  category: 'General',
  description: 'The Creative Insights Report',
  image_url:
    'https://lh3.googleusercontent.com/drive-viewer/AKGpihYsMEACg7Odt6eIzwrn8NkaIu0EgvE_t2d4gMdpiysAzReRP4Gt8sjtQfHZ1IDRPD6OHQieCfVuXyME323NO_uYFeXecMVIl2U=s1600-rw-v1',
  authors: [
    {
      name: 'Tobias Hink',
      email: 'hink@precisdigital.com',
      image_url: 'https://lh3.googleusercontent.com/a-/AOh14GjyNEc4WJk3HgY11avoS-2opMitZKNbLBZcaWvS=s126-p-k-rw-no'
    },
    {
      name: 'Jonas Bæk',
      email: 'jonas@precisdigital.com',
      image_url: 'https://lh3.googleusercontent.com/ogw/AOLn63HCWKXxP5vd6YL-Mw1-yI8FZQ-5i7IZ3Cp6pWV8cg=s256-c-mo'
    },
    {
      name: 'Joella Berg',
      email: 'joella@precisdigital.com',
      image_url: 'https://drive.google.com/uc?id=1uX3nOAOFswYoVXn3gqg3DErkA4xEC2uY'
    }
  ],
  documentation: {
    type: 'knowledge_hub',
    link: 'TBD',
    link_description: 'Knowledge Hub: The Creative Insights Report'
  },
  dashboard: {
    template_report_id: '08a35fe3-9c75-4d14-878f-56a03adb2fdc',
    report_name_template: 'copy of Creative Insights Report - {today}',
    datasources: [
      {
        alias: 'base',
        datasourceName: 'pd_creative_base - {name}',
        type: 'TABLE',
        tableId: 'creative_insights_report_output_base_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'gads',
        datasourceName: 'pd_creative_base - gads - {name}',
        type: 'TABLE',
        tableId: 'creative_insights_report_output_gads_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'meta',
        datasourceName: 'pd_creative_base - meta - {name}',
        type: 'TABLE',
        tableId: 'creative_insights_report_output_meta_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'dv360',
        datasourceName: 'pd_creative_base - dv360 - {name}',
        type: 'TABLE',
        tableId: 'creative_insights_report_output_dv360_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'tiktok',
        datasourceName: 'pd_creative_base - tiktok - {name}',
        type: 'TABLE',
        tableId: 'creative_insights_report_output_tiktok_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      },
      {
        alias: 'linkedin',
        datasourceName: 'pd_creative_base - linkedin - {name}',
        type: 'TABLE',
        tableId: 'creative_insights_report_output_linkedin_{name}',
        isPartitioned: 'true',
        refreshFields: 'false'
      }
    ]
  },
  sources: {
    facebook: {
      reports: [
        'creative_report',
        'platform_placement_report',
        'body_asset_report',
        'call_to_action_asset_report',
        'description_asset_report',
        'title_asset_report',
        'link_url_asset_report'
      ],
      optional: true
    },
    dv360: {
      reports: ['creative_performance', 'youtube_ad_conversions', 'youtube_ad_performance'],
      optional: true
    },
    gads: {
      reports: [
        'ad_group_ad_conversions',
        'asset_group_performance',
        'campaign_conversion_expanded',
        'ad_group_ad_performance',
        'creative_report'
      ],
      optional: true
    },
    linkedin_ads: {
      reports: ['ad_performance', 'ad_conversions', 'creative_report'],
      optional: true
    },
    tiktok: {
      reports: ['ad_performance_base', 'ad_performance_custom_conversions', 'creative_report'],
      optional: true
    },
    snapchat: {
      reports: ['ad_performance_base', 'creative_report'],
      optional: true
    },
    pinterest: {
      reports: ['ad_country_conversions', 'ad_country_performance', 'creative_report'],
      optional: true
    },
    google_sheets: {
      reports: ['creative_insight_joins'],
      optional: true
    }
  },
  inputs: {
    gads: [
      {
        id: 'gadsCustomChannelGrouping',
        type: 'case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in Google Ads.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'customer__descriptive_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'customer__id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign__name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign__id',
            type: 'string'
          },
          {
            label: 'Campaign status',
            value: 'campaign__status',
            type: 'string'
          },
          {
            label: 'Campaign type',
            value: 'campaign__advertising_channel_type',
            type: 'string'
          },
          {
            label: 'Campaign sub type',
            value: 'campaign__advertising_channel_sub_type',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'display'
                }
              ],
              '1': [
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'display'
                }
              ]
            }
          },
          {
            name: 'Paid Search - Brand',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'brand'
                }
              ]
            }
          },
          {
            name: 'Paid Search - Shopping',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'shopping'
                }
              ]
            }
          },
          {
            name: 'Paid Search - PMax',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'pmax'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'performance max'
                }
              ]
            }
          },
          {
            name: 'Paid Search - nonBrand',
            rules: {
              '0': [
                {
                  operator: 'not_equals',
                  dimension: 'campaign__name',
                  value: 'everything else'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'gadsMarketChannelGrouping',
        type: 'case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in Google Ads.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'customer__descriptive_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'customer__id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign__name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign__id',
            type: 'string'
          },
          {
            label: 'Campaign status',
            value: 'campaign__status',
            type: 'string'
          },
          {
            label: 'Campaign type',
            value: 'campaign__advertising_channel_type',
            type: 'string'
          },
          {
            label: 'Campaign sub type',
            value: 'campaign__advertising_channel_sub_type',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'global'
                }
              ]
            }
          },
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'dk'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: '-dk-'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'se'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: '-se-'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'no'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: '-no-'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'fi'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: '-fi-'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'customer__descriptive_name',
                  value: 'de'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign__name',
                  value: '-de-'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'conversionNameFilterGads',
        type: 'string',
        label: 'Conversion Name Filter',
        helperText:
          'Filter the report to only include campaigns with Conversion Names containing this regex (e.g. "purchase|landing_page_view").',
        required: false,
        mutable: true,
        defaultValue: '.*'
      }
    ],
    facebook: [
      {
        id: 'facebookCustomChannelGrouping',
        type: 'case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in Meta Ads.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign buying type',
            value: 'buying_type',
            type: 'string'
          },
          {
            label: 'Campaign objective',
            value: 'objective',
            type: 'string'
          },
          {
            label: 'Ad set name',
            value: 'adset_name',
            type: 'string'
          },
          {
            label: 'Ad set ID',
            value: 'adset_id',
            type: 'string'
          },
          {
            label: 'Ad name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Ad ID',
            value: 'ad_id',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Paid Social - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Paid Social - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'prospecting'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'facebookMarketChannelGrouping',
        type: 'case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in Meta Ads.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign buying type',
            value: 'buying_type',
            type: 'string'
          },
          {
            label: 'Campaign objective',
            value: 'objective',
            type: 'string'
          },
          {
            label: 'Ad set name',
            value: 'adset_name',
            type: 'string'
          },
          {
            label: 'Ad set ID',
            value: 'adset_id',
            type: 'string'
          },
          {
            label: 'Ad name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Ad ID',
            value: 'ad_id',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'dk'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-dk-'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'se'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-se-'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'no'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-no-'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'fi'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-fi-'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'de'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-de-'
                }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'global'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'global'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'conversionNameFilterMeta',
        type: 'string',
        label: 'Conversion Name Filter',
        helperText:
          'Filter the report to only include campaigns with Conversion Names containing this regex (e.g. "purchase|landing_page_view").',
        required: false,
        mutable: true,
        defaultValue: '.*'
      }
    ],
    dv360: [
      {
        id: 'dv360CustomChannelGrouping',
        type: 'case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in DV360.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Advertiser name',
            value: 'filter_advertiser_name',
            type: 'string'
          },
          {
            label: 'Advertiser ID',
            value: 'filter_advertiser',
            type: 'string'
          },
          {
            label: 'Insertion order name',
            value: 'filter_insertion_order_name',
            type: 'string'
          },
          {
            label: 'Insertion order ID',
            value: 'filter_insertion_order',
            type: 'string'
          },
          {
            label: 'Media plan name',
            value: 'filter_media_plan_name',
            type: 'string'
          },
          {
            label: 'Media plan ID',
            value: 'filter_media_plan',
            type: 'string'
          },
          {
            label: 'Line item name',
            value: 'filter_line_item_name',
            type: 'string'
          },
          {
            label: 'Line item ID',
            value: 'filter_line_item',
            type: 'string'
          },
          {
            label: 'Creative type',
            value: 'filter_creative_type',
            type: 'string'
          },
          {
            label: 'Position in content',
            value: 'filter_position_in_content',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'prospecting'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'dv360MarketChannelGrouping',
        type: 'case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in DV360.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Advertiser name',
            value: 'filter_advertiser_name',
            type: 'string'
          },
          {
            label: 'Advertiser ID',
            value: 'filter_advertiser',
            type: 'string'
          },
          {
            label: 'Insertion order name',
            value: 'filter_insertion_order_name',
            type: 'string'
          },
          {
            label: 'Insertion order ID',
            value: 'filter_insertion_order',
            type: 'string'
          },
          {
            label: 'Media plan name',
            value: 'filter_media_plan_name',
            type: 'string'
          },
          {
            label: 'Media plan ID',
            value: 'filter_media_plan',
            type: 'string'
          },
          {
            label: 'Line item name',
            value: 'filter_line_item_name',
            type: 'string'
          },
          {
            label: 'Line item ID',
            value: 'filter_line_item',
            type: 'string'
          },
          {
            label: 'Creative type',
            value: 'filter_creative_type',
            type: 'string'
          },
          {
            label: 'Position in content',
            value: 'filter_position_in_content',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'dk'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: '-dk-'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'se'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: '-se-'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'no'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: '-no-'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'fi'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: '-fi-'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'de'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: '-de-'
                }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'filter_advertiser_name',
                  value: 'global'
                },
                {
                  operator: 'contains',
                  dimension: 'filter_insertion_order_name',
                  value: 'global'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'conversionNameFilterDv360',
        type: 'string',
        label: 'Conversion Name Filter',
        helperText:
          'Filter the report to only include campaigns with Conversion Names containing this regex (e.g. "purchase|landing_page_view").',
        required: false,
        mutable: true,
        defaultValue: '.*'
      }
    ],
    tiktok: [
      {
        id: 'tiktokCustomChannelGrouping',
        type: 'case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in TikTok.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'advertiser_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Objective',
            value: 'objective_type',
            type: 'string'
          },
          {
            label: 'Campaign Dedicate Type',
            value: 'campaign_dedicate_type',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'prospecting'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'tiktokMarketChannelGrouping',
        type: 'case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in TikTok.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'advertiser_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Objective',
            value: 'objective_type',
            type: 'string'
          },
          {
            label: 'Campaign Dedicate Type',
            value: 'campaign_dedicate_type',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'dk'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-dk-'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'se'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-se-'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'no'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-no-'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'fi'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-fi-'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'de'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-de-'
                }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'advertiser_name',
                  value: 'global'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'global'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'conversionNameFilterTikTok',
        type: 'string',
        label: 'Conversion Name Filter',
        helperText:
          'Filter the report to only include campaigns with Conversion Names containing this regex (e.g. "purchase|landing_page_view").',
        required: false,
        mutable: true,
        defaultValue: '.*'
      }
    ],
    linkedin_ads: [
      {
        id: 'linkedinCustomChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in LinkedIn.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Campaign objective',
            value: 'campaign_objective_type',
            type: 'string'
          },
          {
            label: 'Ad name',
            value: 'ad_name',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'prospecting'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'linkedinMarketChannelGrouping',
        type: 'custom_grouping_or_case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in LinkedIn.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Campaign objective',
            value: 'campaign_objective_type',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'dk'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-dk-'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'se'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-se-'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'no'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-no-'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'fi'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-fi-'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'de'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-de-'
                }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'global'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'global'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'conversionNameFilterLinkedin',
        type: 'string',
        label: 'Conversion Name Filter',
        helperText:
          'Filter the report to only include campaigns with Conversion Names containing this regex (e.g. "purchase|landing_page_view").',
        required: false,
        mutable: true,
        defaultValue: '.*'
      }
    ],
    snapchat: [
      {
        id: 'snapchatCustomChannelGrouping',
        type: 'case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in Snapchat.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Objective',
            value: 'objective',
            type: 'string'
          },
          {
            label: 'Ad squad name',
            value: 'ad_squad_name',
            type: 'string'
          },
          {
            label: 'Ad squad ID',
            value: 'ad_squad_id',
            type: 'string'
          },
          {
            label: 'Ad name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Ad ID',
            value: 'ad_id',
            type: 'string'
          },
          {
            label: 'Country',
            value: 'country',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'prospecting'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'snapchatMarketChannelGrouping',
        type: 'case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in Snapchat.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Objective',
            value: 'objective',
            type: 'string'
          },
          {
            label: 'Ad squad name',
            value: 'ad_squad_name',
            type: 'string'
          },
          {
            label: 'Ad squad ID',
            value: 'ad_squad_id',
            type: 'string'
          },
          {
            label: 'Ad name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Ad ID',
            value: 'ad_id',
            type: 'string'
          },
          {
            label: 'Country',
            value: 'country',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'dk'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-dk-'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'se'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-se-'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'no'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-no-'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'fi'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-fi-'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'de'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-de-'
                }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'global'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'global'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'conversionNameFilterSnapchat',
        type: 'string',
        label: 'Conversion Name Filter',
        helperText:
          'Filter the report to only include campaigns with Conversion Names containing this regex (e.g. "purchase|landing_page_view").',
        required: false,
        mutable: true,
        defaultValue: '.*'
      }
    ],
    pinterest: [
      {
        id: 'pinterestCustomChannelGrouping',
        type: 'case_statement',
        label: 'Custom Channel Grouping',
        helperText: 'The Channel Grouping that defines your channels in Pinterest.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'ad_account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign objective type',
            value: 'campaign_objective_type',
            type: 'string'
          },
          {
            label: 'Ad group name',
            value: 'ad_group_name',
            type: 'string'
          },
          {
            label: 'Ad group ID',
            value: 'ad_group_id',
            type: 'string'
          },
          {
            label: 'Ad name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Ad ID',
            value: 'ad_id',
            type: 'string'
          },
          {
            label: 'Country',
            value: 'targeting_value',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Display - Remarketing',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'retargeting'
                }
              ]
            }
          },
          {
            name: 'Display - Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'prospecting'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'pinterestMarketChannelGrouping',
        type: 'case_statement',
        label: 'Custom Market Grouping',
        helperText: 'The Market Grouping that defines your markets in Pinterest.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Account name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'ad_account_id',
            type: 'string'
          },
          {
            label: 'Campaign name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign objective type',
            value: 'campaign_objective_type',
            type: 'string'
          },
          {
            label: 'Ad group name',
            value: 'ad_group_name',
            type: 'string'
          },
          {
            label: 'Ad group ID',
            value: 'ad_group_id',
            type: 'string'
          },
          {
            label: 'Ad name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Ad ID',
            value: 'ad_id',
            type: 'string'
          },
          {
            label: 'Country',
            value: 'targeting_value',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Denmark',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'dk'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'denmark'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-dk-'
                }
              ]
            }
          },
          {
            name: 'Sweden',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'se'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'sweden'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-se-'
                }
              ]
            }
          },
          {
            name: 'Norway',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'no'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'norway'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-no-'
                }
              ]
            }
          },
          {
            name: 'Finland',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'fi'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'finland'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-fi-'
                }
              ]
            }
          },
          {
            name: 'Germany',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'de'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'germany'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-de-'
                }
              ]
            }
          },
          {
            name: 'Global',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'account_name',
                  value: 'global'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'global'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'conversionNameFilterPinterest',
        type: 'string',
        label: 'Conversion Name Filter',
        helperText:
          'Filter the report to only include campaigns with Conversion Names containing this regex (e.g. "purchase|landing_page_view").',
        required: false,
        mutable: true,
        defaultValue: '.*'
      }
    ],
    other: [
      {
        id: 'targetCurrency',
        type: 'dropdown',
        label: 'Target Currency',
        helperText: 'The currency to transform all currency-based columns (cost, revenue, etc) to.',
        required: true,
        defaultValue: 'EUR',
        mutable: true
      },
      {
        id: 'audienceGrouping',
        type: 'case_statement',
        label: 'Audience Grouping',
        helperText: 'The Audience Grouping that defines your audiences.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Platform',
            value: 'platform',
            type: 'string'
          },
          {
            label: 'Account Name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign Name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Adset Name',
            value: 'adset_name',
            type: 'string'
          },
          {
            label: 'Ad Name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Platform Position',
            value: 'platform_position',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Broad',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'advantage+'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'advantage+'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'advantage+'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'broad'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'broad'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'broad'
                }
              ]
            }
          },
          {
            name: 'Retargeting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'remarketing'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'retargeting'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'retargeting'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'retargeting'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 're-engage'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 're-engage'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 're-engage'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 're.engage'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 're.engage'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 're.engage'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '-ret-'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '-ret-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-ret-'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '-rem-'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '-rem-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-rem-'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'reactivation'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'reactivation'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'reactivation'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'warm'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'warm'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'warm'
                }
              ]
            }
          },
          {
            name: 'Prospecting',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'lookalike'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'lookalike'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'lookalike'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'prospecting'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'prospecting'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'prospecting'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '-prospect-'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '-prospect-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-prospect-'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'awareness'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'awareness'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'awareness'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '-see-'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '-see-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-see-'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '_see'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '_see'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '_see'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'cold'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'cold'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'cold'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'adConceptGrouping',
        type: 'case_statement',
        label: 'Ad Concept Grouping',
        helperText: 'The Ad Concept Grouping that defines your ad concepts.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Platform',
            value: 'platform',
            type: 'string'
          },
          {
            label: 'Account Name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign Name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Adset Name',
            value: 'adset_name',
            type: 'string'
          },
          {
            label: 'Ad Name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Platform Position',
            value: 'platform_position',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Price',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'price'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'price'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'price'
                }
              ]
            }
          },
          {
            name: 'Trend',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'trend'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'trend'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'trend'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'adFormatGrouping',
        type: 'case_statement',
        label: 'Ad Format Grouping',
        helperText: 'The Ad Format Grouping that defines your ad formats.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Platform',
            value: 'platform',
            type: 'string'
          },
          {
            label: 'Account Name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign Name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Adset Name',
            value: 'adset_name',
            type: 'string'
          },
          {
            label: 'Ad Name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Platform Position',
            value: 'platform_position',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Reel',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'reel'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'reel'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'reel'
                }
              ]
            }
          },
          {
            name: 'Stories',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'story'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'story'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'story'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'stories'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'stories'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'stories'
                }
              ]
            }
          },
          {
            name: 'Carousel',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'carousel'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'carousel'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'carousel'
                }
              ]
            }
          },
          {
            name: 'Lead',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'lead'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'lead'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'lead'
                }
              ]
            }
          },
          {
            name: 'Poll',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'poll'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'poll'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'poll'
                }
              ]
            }
          },
          {
            name: 'Collection',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'collection'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'collection'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'collection'
                }
              ]
            }
          },
          {
            name: 'DPA',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'dpa'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'dpa'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'dpa'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'dynamic'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'dynamic'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'dynamic'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'testGrouping',
        type: 'case_statement',
        label: 'Test Grouping',
        helperText: 'The Test Grouping that defines your tests.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Platform',
            value: 'platform',
            type: 'string'
          },
          {
            label: 'Account Name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign Name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Adset Name',
            value: 'adset_name',
            type: 'string'
          },
          {
            label: 'Ad Name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Platform Position',
            value: 'platform_position',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Test',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'test'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'test'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'test'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'conversionGrouping',
        type: 'case_statement',
        label: 'Conversion Grouping',
        helperText: 'The Conversion Grouping that groups conversion actions',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Conversion Name',
            value: 'conversion_name',
            type: 'string'
          },
          {
            label: 'Conversion Source',
            value: 'conversion_source',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Video View',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'video_view'
                }
              ]
            }
          },
          {
            name: 'Post Engagement',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'like'
                }
              ]
            }
          },
          {
            name: 'Post Engagement',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'post_reaction'
                }
              ]
            }
          },
          {
            name: 'Landing Page View',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'landing_page_view'
                }
              ]
            }
          },
          {
            name: 'View Content',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_view_content'
                }
              ]
            }
          },
          {
            name: 'Added to Wishlist',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_add_to_wishlist'
                }
              ]
            }
          },
          {
            name: 'Add to Cart',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_add_to_cart'
                }
              ]
            }
          },
          {
            name: 'Checkout',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_initiate_checkout'
                }
              ]
            }
          },
          {
            name: 'Payment Info',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_add_payment_info'
                }
              ]
            }
          },
          {
            name: 'Purchase',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_purchase'
                }
              ]
            }
          },
          {
            name: 'Leads',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_lead'
                }
              ]
            }
          },
          {
            name: 'Leads',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_complete_registration'
                }
              ]
            }
          },
          {
            name: 'Search',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_search'
                }
              ]
            }
          },
          {
            name: 'Contact',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_contact'
                }
              ]
            }
          },
          {
            name: 'Product Customization',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_customize_product'
                }
              ]
            }
          },
          {
            name: 'Trial Start',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_start_trial'
                }
              ]
            }
          },
          {
            name: 'Application Submission',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_submit_application'
                }
              ]
            }
          },
          {
            name: 'Subscription',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_subscribe'
                }
              ]
            }
          },
          {
            name: 'Location Search',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_find_location'
                }
              ]
            }
          },
          {
            name: 'Schedule',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_schedule'
                }
              ]
            }
          },
          {
            name: 'Donation',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'offsite_conversion.fb_pixel_donate'
                }
              ]
            }
          },
          {
            name: 'Purchase',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'purchase'
                }
              ]
            }
          },
          {
            name: 'Leads',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'lead'
                }
              ]
            }
          },
          {
            name: 'Contact',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'contact'
                }
              ]
            }
          },
          {
            name: 'Add to Cart',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'add_to_cart'
                }
              ]
            }
          },
          {
            name: 'Checkout',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'checkout'
                }
              ]
            }
          },
          {
            name: 'App Install',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'conversion_name',
                  value: 'app_install'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'funnelGrouping',
        type: 'case_statement',
        label: 'Funnel Grouping',
        helperText: 'The Funnel Grouping that defines your funnels.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Platform',
            value: 'platform',
            type: 'string'
          },
          {
            label: 'Account Name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign Name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Adset Name',
            value: 'adset_name',
            type: 'string'
          },
          {
            label: 'Ad Name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Platform Position',
            value: 'platform_position',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Upper Funnel',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'awareness'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'awareness'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'awareness'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'aware'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'aware'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'aware'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '-see-'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '-see-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-see-'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '_see_'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '_see_'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '_see_'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '-upper-'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '-upper-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-upper-'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '_upper_'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '_upper_'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '_upper_'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '-tof-'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '-tof-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-tof-'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '_tof_'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '_tof_'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '_tof_'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'educate'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'educate'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'educate'
                }
              ]
            }
          },
          {
            name: 'Mid Funnel',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'consideration'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'consideration'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'consideration'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'consid'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'consid'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'consid'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'interest'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'interest'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'interest'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'think'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'think'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'think'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '-mof-'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '-mof-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-mof-'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '_mof_'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '_mof_'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '_mof_'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '-mid-'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '-mid-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-mid-'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '_mid_'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '_mid_'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '_mid_'
                }
              ]
            }
          },
          {
            name: 'Lower Funnel',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'decision'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'decision'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'decision'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'action'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'action'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'action'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'convert'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'convert'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'convert'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'conversion'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'conversion'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'conversion'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '-lower-'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '-lower-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-lower-'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '_lower_'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '_lower_'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '_lower_'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '-bof-'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '-bof-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-bof-'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '_bof_'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '_bof_'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '_bof_'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'acquisition'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'acquisition'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'acquisition'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '-do-'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '-do-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-do-'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '_do_'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '_do_'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '_do_'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'care'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'care'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'care'
                }
              ]
            }
          },
          {
            name: 'Always On',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'alwayson'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'alwayson'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'alwayson'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'always-on'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'always-on'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'always-on'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'always_on'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'always_on'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'always_on'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '-ao-'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '-ao-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-ao-'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '_ao_'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '_ao_'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '_ao_'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'customCampaignType',
        type: 'case_statement',
        label: 'Custom Campaign Type',
        helperText: 'The Campaign Type Grouping that defines your campaign types.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Platform',
            value: 'platform',
            type: 'string'
          },
          {
            label: 'Account Name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign Name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Adset Name',
            value: 'adset_name',
            type: 'string'
          },
          {
            label: 'Ad Name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Platform Position',
            value: 'platform_position',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Always On',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'alwayson'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'alwayson'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'alwayson'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'always-on'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'always-on'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'always-on'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'always_on'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'always_on'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'always_on'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '-ao-'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '-ao-'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '-ao-'
                },
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: '_ao_'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: '_ao_'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: '_ao_'
                }
              ]
            }
          },
          {
            name: 'Sale',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'sale'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'sale'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'sale'
                }
              ]
            }
          },
          {
            name: 'Campaign Push',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'push'
                },
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'push'
                },
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'push'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'customGrouping1',
        type: 'case_statement',
        label: 'Custom Grouping 1',
        helperText: 'The Custom Grouping 1 that defines your custom grouping.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Platform',
            value: 'platform',
            type: 'string'
          },
          {
            label: 'Account Name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign Name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Adset Name',
            value: 'adset_name',
            type: 'string'
          },
          {
            label: 'Ad Name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Platform Position',
            value: 'platform_position',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Promotional',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'ad_name',
                  value: 'promo'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'customGrouping2',
        type: 'case_statement',
        label: 'Custom Grouping 2',
        helperText: 'The Custom Grouping 2 that defines your custom grouping.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Platform',
            value: 'platform',
            type: 'string'
          },
          {
            label: 'Account Name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign Name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Adset Name',
            value: 'adset_name',
            type: 'string'
          },
          {
            label: 'Ad Name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Platform Position',
            value: 'platform_position',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Holiday Season',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'holiday'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'customGrouping3',
        type: 'case_statement',
        label: 'Custom Grouping 3',
        helperText: 'The Custom Grouping 3 that defines your custom grouping.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Platform',
            value: 'platform',
            type: 'string'
          },
          {
            label: 'Account Name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign Name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Adset Name',
            value: 'adset_name',
            type: 'string'
          },
          {
            label: 'Ad Name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Platform Position',
            value: 'platform_position',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Geotargeted',
            rules: {
              '0': [
                {
                  operator: 'contains',
                  dimension: 'adset_name',
                  value: 'geo'
                }
              ]
            }
          }
        ]
      },
      {
        id: 'customGrouping4',
        type: 'case_statement',
        label: 'Custom Grouping 4',
        helperText: 'The Custom Grouping 4 that defines your custom grouping.',
        required: false,
        mutable: true,
        dimensions: [
          {
            label: 'Platform',
            value: 'platform',
            type: 'string'
          },
          {
            label: 'Account Name',
            value: 'account_name',
            type: 'string'
          },
          {
            label: 'Account ID',
            value: 'account_id',
            type: 'string'
          },
          {
            label: 'Campaign Name',
            value: 'campaign_name',
            type: 'string'
          },
          {
            label: 'Campaign ID',
            value: 'campaign_id',
            type: 'string'
          },
          {
            label: 'Campaign Type',
            value: 'campaign_type',
            type: 'string'
          },
          {
            label: 'Adset Name',
            value: 'adset_name',
            type: 'string'
          },
          {
            label: 'Ad Name',
            value: 'ad_name',
            type: 'string'
          },
          {
            label: 'Platform Position',
            value: 'platform_position',
            type: 'string'
          }
        ],
        defaultValue: [
          {
            name: 'Click Focused',
            rules: {
              '0': [
                {
                  operator: 'equals',
                  dimension: 'platform',
                  value: 'gads'
                }
              ],
              '1': [
                {
                  operator: 'contains',
                  dimension: 'campaign_name',
                  value: 'click'
                }
              ]
            }
          }
        ]
      }
    ]
  }
}

export default config
